import { render, staticRenderFns } from "./WF6_Communication.vue?vue&type=template&id=ad6cc7f4&scoped=true"
import script from "./WF6_Communication.vue?vue&type=script&lang=js"
export * from "./WF6_Communication.vue?vue&type=script&lang=js"
import style0 from "./WF6_Communication.vue?vue&type=style&index=0&id=ad6cc7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6cc7f4",
  null
  
)

export default component.exports